import { PatientData } from "../types/Patient";
import { patientApiUrl } from "./api";

const API_URL = "/Patients";

export const getData = async (): Promise<PatientData[]> => {
  try {
    const res = await patientApiUrl.get<PatientData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all patients error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getPatientIdsData = async (): Promise<number[]> => {
  try {
    const res = await patientApiUrl.get<number[]>(`${API_URL}/patient-ids`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get patient ids error: ${error.response?.data?.message || error.message}`
    );
    return [];
  }
};

export const getDataById = async (id: number): Promise<PatientData | null> => {
  try {
    const res = await patientApiUrl.get<PatientData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get patient error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const createData = async (
  data: Partial<PatientData>
): Promise<PatientData | null> => {
  try {
    const res = await patientApiUrl.post<PatientData>(API_URL, data);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create patient error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  data: Partial<PatientData>
): Promise<PatientData | null> => {
  try {
    const res = await patientApiUrl.put<PatientData>(`${API_URL}/${id}`, data);
    return res.data;
  } catch (error: any) {
    console.error(
      `Update patient error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await patientApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete patient error: ${error.response?.data?.message || error.message}`
    );
    return false;
  }
};
